import * as yup from "yup";

const extraChargeValidationSchema = yup.object().shape({
    descriptionOther: yup
        .string()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),

    price: yup
        .number()
        .positive('Deve essere un numero positivo')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});

export default extraChargeValidationSchema;